import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'div [export-help]',
  templateUrl: 'export-help.component.html',
  host: { '[class.container_export_help]': '\'true\'' }
})
export class ExportHelpComponent {
  @Input()
  pageNumber: string;

  constructor(private router: Router){

  }

  // openGuide(numPagina): string {
  //   let url: string = '';
  //   let porta: string = window.location.port;
  //   let hostServicesAddress: string = window.location.protocol + '//' + window.location.host + '/services';
  //   if ((~hostServicesAddress.indexOf('localhost') || ~hostServicesAddress.indexOf('127.0.0.1')) && (porta === '3000' || porta === '4200') ) {
  //     return window.location.protocol + '//' + window.location.host + '/assets/guida_utente.pdf' + numPagina;
  //   } else {
  //     return window.location.protocol + '//' + window.location.host + '/teleforumweb/assets/guida_utente.pdf' + numPagina;
  //   }
  // }

  openGuide(): string {

    let porta: string = window.location.port;
    let hostServicesAddress: string = window.location.protocol + '//' + window.location.host + '/services';
    if ((~hostServicesAddress.indexOf('localhost') || ~hostServicesAddress.indexOf('127.0.0.1')) && (porta === '3000' || porta === '4200') ) {
      return window.location.protocol + '//' + window.location.host + '/guida_utente.pdf' + this.pageNumber;
    } else {
      return window.location.protocol + '//' + window.location.host + '/static/teleforum/guida_utente.pdf';
    }
  }

}
